import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, TableCell, TableRow } from "@mui/material";
import { IMaterial } from "../../interfaces";
import { MaterialIdentifiers } from "../Shared/MaterialIdentifiers";
import { MaterialInfo } from "../Shared/MaterialInfo";

interface MCTRow {
    material: IMaterial,
    readOnly: boolean,
    consumed: (string | undefined)[],
    onConsume: (consume: boolean) => void,
    onUndo: (() => void) | undefined,
}


export const MaterialConsumableTableRow: React.FC<MCTRow> = ({
    material,
    readOnly,
    consumed,
    onConsume,
    onUndo,
    ...props
}) => {



    const getActionColumnStyle = (statusId: number) => {

        return (statusId === 1 && !readOnly) ? { width: '180px' } : {};

    }

    return (
        <TableRow className="material-row" >
            <TableCell>
                <Accordion elevation={0}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                    >
                        <div>
                            <p><strong>{material.l3}</strong></p>
                            <small>{material.l1?.value}</small>
                            <small>{material.l2?.value}</small>
                        </div>

                    </AccordionSummary>
                    <AccordionDetails>
                        <MaterialInfo material={material} />
                    </AccordionDetails>
                </Accordion>
            </TableCell>
            <TableCell>
                <p>{material.classes} </p>
            </TableCell>
            <TableCell>
                <p>{material.spareType?.value}</p>
            </TableCell>
            <TableCell>
                <MaterialIdentifiers material={material} />
            </TableCell>
            <TableCell>
                <p>{material.state?.value}</p>
            </TableCell>
            <TableCell>
                <p>
                    {material.quantity}
                    <span>({material.unitOfQuantity?.value})</span>
                </p>
            </TableCell>


            <TableCell sx={getActionColumnStyle(material.statusId ?? 0)}>

                <Checkbox
                    onChange={(e) => onConsume(e.target.checked)}
                    checked={consumed.includes(material.materialId) ?? false}
                    disabled={readOnly}
                />

            </TableCell>


            {(onUndo !== undefined && !readOnly) &&
                <TableCell>
                    <Button
                        title="Undo"
                        variant="outlined"
                        color="warning"
                        onClick={onUndo}
                    >
                        Undo
                    </Button>
                </TableCell>
            }

        </TableRow >
    );
}

